import { connect } from "react-redux";
import { SignUpPage } from "./sign-up-page";
import { create } from "../../actions/register";

export const SignUpContainer = connect(null, {
    onSubmit: create,
})(SignUpPage);
